module.exports = __webpack_public_path__ + "img/logo1.bb5819a4.png";